// JS FUNCTIONS TRIGGERED BEFORE FUNCTIONS FROM theme.js ARE EXECUTED

$(document).ready(function(){
	replace_video_id();
});

// REPLACES VIDEO ID IN SLIDE SHOW AND HERO-VIDEO
function replace_video_id() {
	
	if ($(window).width() < 768) {
		$('[data-video-mobile-id]').each(function(){
			var mobile_id = $(this).data('video-mobile-id');
			$(this).data('video-id', mobile_id);
		});
	}
	
}
